import { render, staticRenderFns } from "./A7ClassificacaoIndicadorEntityChooser.vue?vue&type=template&id=74350812&scoped=true&"
import script from "./A7ClassificacaoIndicadorEntityChooser.vue?vue&type=script&lang=js&"
export * from "./A7ClassificacaoIndicadorEntityChooser.vue?vue&type=script&lang=js&"
import style0 from "./A7ClassificacaoIndicadorEntityChooser.vue?vue&type=style&index=0&id=74350812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74350812",
  null
  
)

export default component.exports